import React from "react";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import type { BlocksContent } from "@strapi/blocks-react-renderer";
import { commonBlocksOverrides, commonModifiersOverrides } from "@ui/components/common/blocks-overrides";

interface BaseBlocksRendererProps {
	content: BlocksContent;
	blocks?: typeof commonBlocksOverrides;
	modifiers?: typeof commonModifiersOverrides;
}

export const BaseBlocksRenderer: React.FC<BaseBlocksRendererProps> = ({
	content,
	blocks = commonBlocksOverrides,
	modifiers = commonModifiersOverrides,
}) => <BlocksRenderer content={content} blocks={blocks} modifiers={modifiers} />;
